import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

const FinalizeNewUserSchema = z.object({
  email: z.string().email(),
  password: z.string(),
  firstName: z.string(),
  lastName: z.string(),
});

const FinalizeExistingUserSchema = z.object({
  email: z.string().email(),
  password: z.string(),
});

const MenuInputRefSchema = z.object({
  type: z.enum(["photo", "pdf", "url", "text"]),
  storageKey: z.string().nullish(),
  mimeType: z.string().nullish(),
  urlOrText: z.string().nullish(),
  label: z.string().nullish(),
});

const FinalizeBodySchema = z.object({
  newUser: FinalizeNewUserSchema.optional(),
  existingUser: FinalizeExistingUserSchema.optional(),
  salonName: z.string().min(1),
  address: z.string().min(1),
  addressLine2: z.string().nullish(),
  city: z.string().nullish(),
  postalCode: z.string().nullish(),
  state: z.string().nullish(),
  country: z.string().nullish(),
  phone: z.string().nullish(),
  timezone: z.string().nullish(),
  currency: z.string().min(1),
  defaultLanguage: z.string().nullish(),
  hoursText: z.string().nullish(),
  menuInput: MenuInputRefSchema.nullish(),
});

const FinalizeResponseSchema = z.object({
  queueEntryId: z.string(),
  queuePosition: z.number(),
  userId: z.string(),
  paused: z.boolean(),
});

// `code` carries the SalonException code (e.g. "emailAlreadyExists") so the
// caller can branch on the specific failure, not just the message text.
const errorSchema = z.object({ message: z.string(), code: z.string().optional() });

/**
 * Onboarding "Create Account & Go Live" finalize. Internal, HMAC-guarded
 * (x-webhook-signature / x-webhook-timestamp) — deliberately not public, so
 * the abuse-prone signup + login path can't be hit directly from the internet.
 */
export const onboardingContract = c.router({
  finalize: {
    method: "POST",
    path: "/api/onboarding/finalize",
    body: FinalizeBodySchema,
    responses: {
      200: FinalizeResponseSchema,
      400: errorSchema,
      401: errorSchema,
      409: errorSchema,
    },
    summary: "Finalize an onboarding submission (create or attach a salon)",
  },
});
